if (!customElements.get('starter-tcg-hero')) {
  customElements.define(
    'starter-tcg-hero',
    class StarterTcgHero extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => {
          setTimeout(() => this.classList.add('in'), 120);
        });
      }
    }
  );
}
